export const GET_CHATS_REQUEST = 'GET_CHATS_REQUEST';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';

export const CREATE_CHAT_REQUEST = 'CREATE_CHAT_REQUEST';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';

export const GET_CHATS_DROPDOWN_SUCCESS = 'GET_CHATS_DROPDOWN_SUCCESS';
export const UPDATE_CHAT_REQUEST = 'UPDATE_CHAT_REQUEST'

export const GET_CHAT_BY_ID_REQUEST = 'GET_CHAT_BY_ID_REQUEST'
export const GET_CHAT_BY_ID_SUCCESS = 'GET_CHAT_BY_ID_SUCCESS'

export const GET_CHAT_MEDIA_REQUEST = 'GET_CHAT_MEDIA_REQUEST'
export const GET_CHAT_MEDIA_SUCCESS = 'GET_CHAT_MEDIA_SUCCESS'

export const DELETE_CHAT_REQUEST = 'DELETE_CHAT_REQUEST'
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS'

export const ADD_MEMBER_IN_CHAT_REQUEST = 'ADD_MEMBER_IN_CHAT_REQUEST'
export const ADD_MEMBER_IN_CHAT_SUCCESS = 'ADD_MEMBER_IN_CHAT_SUCCESS'

export const GET_MEMBER_IN_CHAT_REQUEST = 'GET_MEMBER_IN_CHAT_REQUEST'
export const GET_MEMBER_IN_CHAT_SUCCESS = 'GET_MEMBER_IN_CHAT_SUCCESS'


export const REMOVE_MEMBER_IN_CHAT_REQUEST = 'REMOVE_MEMBER_IN_CHAT_REQUEST'
export const REMOVE_MEMBER_IN_CHAT_SUCCESS = 'REMOVE_MEMBER_IN_CHAT_SUCCESS'

export const UPDATE_MEMBER_ROLE_IN_CHAT_REQUEST = 'UPDATE_MEMBER_ROLE_IN_CHAT_REQUEST'
export const UPDATE_MEMBER_ROLE_IN_CHAT_SUCCESS = 'UPDATE_MEMBER_ROLE_IN_CHAT_SUCCESS'

export const GET_CHAT_MESSAGES_REQUEST = 'GET_CHAT_MESSAGES_REQUEST'
export const GET_CHAT_MESSAGES_SUCCESS = 'GET_CHAT_MESSAGES_SUCCESS'

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'

export const GET_CHAT_USERS_REQUEST = 'GET_CHAT_USERS_REQUEST'
export const GET_CHAT_USERS_SUCCESS = 'GET_CHAT_USERS_SUCCESS'

export const LIVE_MESSAGE_DATA = 'LIVE_MESSAGE_DATA'
export const DELETE_LIVE_MESSAGE_DATA = 'DELETE_LIVE_MESSAGE_DATA'
export const EDIT_LIVE_MESSAGE_DATA = 'EDIT_LIVE_MESSAGE_DATA'
export const MEMBERS_ADDED_OR_DELETE = 'MEMBERS_ADDED_OR_DELETE'

export const OPEN_CHAT_MODAL_REQUEST = 'OPEN_CHAT_MODAL_REQUEST';
export const OPEN_CHAT_MODAL_SUCCESS = 'OPEN_CHAT_MODAL_SUCCESS';
export const CLOSE_CHAT_MODAL_REQUEST = 'CLOSE_CHAT_MODAL_REQUEST';
export const CLOSE_CHAT_MODAL_SUCCESS = 'CLOSE_CHAT_MODAL_SUCCESS';

export const EDIT_CHAT_MESSAGE_REQUEST = 'EDIT_CHAT_MESSAGE_REQUEST';
export const EDIT_CHAT_MESSAGE_SUCCESS = 'EDIT_CHAT_MESSAGE_SUCCESS';

export const DELETE_CHAT_MESSAGE_REQUEST = 'DELETE_CHAT_MESSAGE_REQUEST';
export const DELETE_CHAT_MESSAGE_SUCCESS = 'DELETE_CHAT_MESSAGE_SUCCESS';
export const EDITING_MESSAGE = 'EDITING_MESSAGE';


export const NEW_MESSAGE_CHAT_ID = 'NEW_MESSAGE_CHAT_ID'
export const TAKE_CHAT_AT_FIRST_POSITION = 'TAKE_CHAT_AT_FIRST_POSITION'

export const UPDATE_CHAT_BY_ID_REQUEST = 'UPDATE_CHAT_BY_ID_REQUEST'
export const UPDATE_CHAT_BY_ID_SUCCESS = 'UPDATE_CHAT_BY_ID_SUCCESS'

export const ADD_TEAMS_TO_CHAT_REQUEST = 'ADD_TEAMS_TO_CHAT_REQUEST'
export const ADD_TEAMS_TO_CHAT_SUCCESS = 'ADD_TEAMS_TO_CHAT_SUCCESS'

export const REMOVE_TEAMS_FROM_CHAT_REQUEST = 'REMOVE_TEAMS_FROM_CHAT_REQUEST'
export const REMOVE_TEAMS_FROM_CHAT_SUCCESS = 'REMOVE_TEAMS_FROM_CHAT_SUCCESS'


export const GET_CHAT_LOGS_REQUEST = 'GET_CHAT_LOGS_REQUEST'
export const GET_CHAT_LOGS_SUCCESS = 'GET_CHAT_LOGS_SUCCESS'

export const READ_MESSAGE_REQUEST = 'READ_MESSAGE_REQUEST'
export const READ_MESSAGE_SUCCESS = 'READ_MESSAGE_SUCCESS'

export const CLEAR_CHAT_MESSAGES = 'CLEAR_CHAT_MESSAGES'

export const UPDATE_MEDIA_STATUS_REQUEST = 'UPDATE_MEDIA_STATUS_REQUEST';
export const UPDATE_MEDIA_STATUS_SUCCESS = 'UPDATE_MEDIA_STATUS_SUCCESS';

export const CHAT_NOTIFICATION_REQUEST = 'CHAT_NOTIFICATION_REQUEST';
export const CHAT_NOTIFICATION_SUCCESS = 'CHAT_NOTIFICATION_SUCCESS';
export const GET_CHAT_AND_SET_AT_FIRST = 'GET_CHAT_AND_SET_AT_FIRST';


export const CLOSE_CHAT_REQUEST = 'CLOSE_CHAT_REQUEST';
export const CLOSE_CHAT_SUCCESS = 'CLOSE_CHAT_SUCCESS';

export const CUSTOMER_MEDIA_SUCCESS = 'CUSTOMER_MEDIA_SUCCESS'
export const GET_CUSTOMER_MEDIA_REQUEST = 'GET_CUSTOMER_MEDIA_REQUEST'


export const GET_USERS_FOR_MENTIONS_REQUEST = 'GET_USERS_FOR_MENTIONS_REQUEST'
export const GET_USERS_FOR_MENTIONS_SUCCESS = 'GET_USERS_FOR_MENTIONS_SUCCESS'